import * as React from "react";
import { IFilterData } from "./FilterData";
import Autoselect from "./Autoselect";
import clsx from "clsx";

interface Props {
	onChange: (value: IFilterData) => void,
	typeName: string,
	changing: boolean,
	className: string,
	noOptionsMessage: string,
	placeholder: string
}

interface State {
	options: IFilterData[],
	isLoading: boolean,
	value?: string,
	needRefreshOptions: boolean,
}

export default class FilterAutocomplete extends React.Component<Props, State> {

	constructor(props) {
		super(props);
		this.state = {
			options: [],
			isLoading: false,
			value: null,

			needRefreshOptions: true,
		};
	}
	
	setFiltersByNameOrExpression(filterNameOrExpression: string, callback: (data: any) => void) {
		let $ = (window as any).$;
		$.ajax({
			url: "/Filters/GetFiltersByNameOrExpression/",
			dataType: 'json',
			cache: false,
			data: {
				filterNameOrExpression: filterNameOrExpression,
				typeName: this.props.typeName,
			},
			success: (data) => {
				if (data != null) {
					let result = this.mapFilterData(data);
					var options = [];
					if (typeof this.state.options != "boolean") {
						options = this.state.options;
					}
					options.push(result);

					this.setState({
						options: options,
						needRefreshOptions: true,
					});
					this.handleChange(result);
				}

				callback(data);
			}
		});
	}
	
	downloadFilter(id: string, fnSelected) {
		let $ = (window as any).$;
		$.ajax({
			url: "/Filters/GetFilter/",
			dataType: 'json',
			cache: false,
			data: {
				filterId: id
			},
			success: (data) => {
				fnSelected(this.mapFilterData(data));
			}
		});
	}
	
	setValue(value: string) {
		this.setState({ value: value });
		if (value) {
			this.downloadFilter(value, (data: IFilterData) => {
				this.setState({
					options: [data],
					needRefreshOptions: true
				});
				this.props.onChange(data);
			});
		}
		else {
			this.props.onChange(null);
		}
	}

	getValue(): IFilterData {
		return this.getById(this.state.value);
	}

	handleChange(value: IFilterData) {
		if (value)
			this.setState({ value: value.Id });
		else
			this.setState({ value: null });

		if (this.props.onChange)
			this.props.onChange(value);
	}

	mapFilterData(item): IFilterData {
		return {
			Id: item.Id,
			Name: item.Name,
			Expression: item.Expression,
			TypeName: item.TypeName,
			KindList: item.KindList,
			IsPrivate: item.IsPrivate,
			Predefined: item.Predefined,

			label: !item.Name && !item.CreatedBy
				? ''
				: item.Name + ' (' + item.CreatedBy + ')',
			value: item.Id,
		};
	}

	handleFocus() {
		
		if (this.state.isLoading)
			return;

		if (!this.state.needRefreshOptions)
			return;
		
		this._refresh();
	}

	public refresh() {
		this._refresh((data) => {
			var selected = this.getById(this.state.value, data);
			if (this.state.value && selected == null) {
				this.setState({ value: null });

				this.props.onChange(null);
			}
		});
	}

	private _refresh(callback?: (data: IFilterData[]) => void) {
		this.setState({ isLoading: true });

		(window as any).$.ajax({
			url: "/Filters/GetFiltersAutocomplete/",
			dataType: 'json',
			cache: false,
			data: {
				MaxRows: 99,
				StartsWith: "",
				typeName: this.props.typeName,
			},
			success: (data) => {
				let options = (window as any).$.map(data, this.mapFilterData);
				this.setState({
					needRefreshOptions: false,
					isLoading: false,
					options: options,
				});

				if (callback)
					callback(options);
			}
		});
	}

	getById(value: string, options?: IFilterData[]): IFilterData {
		if (!options) {
			options = this.state.options;
		}

		for (let i = 0; i < options.length; i++) {
			let op = options[i];
			if (op.value == value)
				return op;
		}
		return null;
	}
	
	render() {
		return <div className={this.props.className}>
			<Autoselect
				className={clsx({
					"changing": this.props.changing,
				})}
				changing={this.props.changing}
				value={this.getById(this.state.value)}
				options={this.state.options}
				isLoading={this.state.isLoading}

				onChange={this.handleChange.bind(this)}
				onFocus={this.handleFocus.bind(this)}

				noOptionsMessage={this.props.noOptionsMessage}
				placeholder={this.props.placeholder}
			/>
		</div>
	}
}